import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import ColDynamic from "../WrapperComponents/ColDynamic";
import "../EntryForm1/EntryForm1.css";

const ContactInformationMultiple = (props) => {
  let contactInformation = props.parentState.newFormData.contactInformation.find(
    (element) => element.id == props.id
  );
  const arrayLength =
    props.parentState.newFormData.contactInformation.length > 1;

  return (
    <>
      <div className="form-group">
        <Row>
          <Col>
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.prezime.length < 1 &&
                "red"
              }
              onChange={props.mappedUserInputHandler}
              objData={{ id: props.id, group: "contactInformation" }}
              value={contactInformation.prezime}
              id={`prezime-contact-info${props.id}`}
              name="prezime"
              controlLabel={"Prezime"}
            />
          </Col>
          <Col>
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.ime.length < 1 &&
                "red"
              }
              onChange={props.mappedUserInputHandler}
              objData={{ id: props.id, group: "contactInformation" }}
              value={contactInformation.ime}
              id={`ime-contact-info${props.id}`}
              name="ime"
              controlLabel={"Ime"}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.telefon.length < 1 &&
                "red"
              }
              onChange={props.mappedUserInputHandler}
              objData={{ id: props.id, group: "contactInformation" }}
              value={contactInformation.telefon}
              id={`telefon-contact-info${props.id}`}
              name="telefon"
              controlLabel={"Broj telefona"}
            />
          </Col>
          <Col>
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.web.length < 1 &&
                "red"
              }
              onChange={props.mappedUserInputHandler}
              objData={{ id: props.id, group: "contactInformation" }}
              value={contactInformation.web}
              id={`web-contact-info${props.id}`}
              name="web"
              controlLabel={"Adresa internetske stranice"}
            />
          </Col>
        </Row>
        <Row>
          <ColDynamic className="col-lg-8 input-style">
            <InputComponent
              required={props.required}
              style={
                (props.required &&
                  props.parentState.error &&
                  contactInformation.email.length < 1) ||
                (props.parentState.error &&
                  contactInformation.email.length > 0 &&
                  !contactInformation.emailValidated &&
                  "red")
              }
              onChange={props.mappedUserInputHandler}
              objData={{ id: props.id, group: "contactInformation" }}
              value={contactInformation.email}
              id={`email-contact-info${props.id}`}
              name="email"
              controlLabel={"Email"}
            />

            {
              //validacija na email
              !contactInformation.emailValidated &&
                contactInformation.email.length > 0 &&
                props.parentState.error && (
                  <p style={{ color: "red" }}>
                    E-mail koji ste upisali nije ispravan!
                  </p>
                )
            }
          </ColDynamic>
        </Row>

        <Row>
          <ColDynamic className="col-lg-4">
            {props.parentState.newFormData.contactInformation.length - 1 === props.idZaBtn ?
              <ButtonComponent
                id={`multiply-component-button-contact-info${props.id}`}
                onClick={(e) =>
                  props.multiplyComponent(e, { formGroup: "contactInformation" })
                }
              >
                Dodaj novi
            </ButtonComponent>
            : null
             }
            
          </ColDynamic>
          <ColDynamic className="col-lg-4">
            {arrayLength && (
              <ButtonComponent
                id={`remove-comp-btn-contact-info${props.id}`}
                variant="danger"
                onClick={(e) =>
                  props.removeComponentHandler(e, {
                    formGroup: "contactInformation",
                  })
                }
              >
                Ukloni
              </ButtonComponent>
            )}
          </ColDynamic>
        </Row>
      </div>
    </>
  );
};

export default ContactInformationMultiple;
